module.exports = __webpack_public_path__ + "static/media/default.e630cb64.png";